// 에너지 탭의 recharts 선 차트(실측+예측 타임라인 · 에너지 추이)가 같이 쓰는 치수 · 축 스타일.
// 차트마다 높이 · 축 폭 · 글자 크기가 달라 플롯 영역이 어긋나 보이던 걸 한 곳에서 맞춘다.
export const CHART_HEIGHT = 160;
// 위 28px 은 단위 라벨 "(W)" · "지금" 라벨 자리. 왼쪽 음수는 YAxis 폭의 빈 여백을 당겨 플롯을 넓힌다.
export const CHART_MARGIN = { top: 28, right: 16, left: -12, bottom: 0 };
export const Y_AXIS_WIDTH = 48;
export const AXIS_COLOR = "#A0A0A0";
export const GRID_STROKE = "rgba(160, 190, 215, 0.12)";
export const AXIS_TICK = { fill: AXIS_COLOR, fontSize: 11 };

// Y축 위 단위 라벨. 두 차트 같은 자리.
export const unitLabel = (unit) => ({
  value: `(${unit})`,
  position: "top",
  offset: 12,
  dx: 10,
  style: { fill: AXIS_COLOR, fontSize: 11 },
});
